<script setup lang="ts">
/**
 * TYPES
 */
type Props = {
  show: boolean;
  onClose: () => void;
};

const bottomReached = ref(false);

/**
 * PROPS & EMITS
 */

const props = defineProps<Props>();

/**
 * HANDLERS
 */
const onContentScroll = (evt: UIEvent) => {
  const { scrollTop, clientHeight, scrollHeight } = evt.target;
  if (Math.ceil(scrollTop) + clientHeight >= scrollHeight) {
    bottomReached.value = true;
  } else {
    bottomReached.value = false;
  }
};
</script>

<template>
  <teleport to="#modal">
    <BalModal
      maxWidth="70%"
      :show="show"
      title="Risk Disclaimer"
      :clickBgToHide="false"
      @close="onClose"
    >
      <div
        class="flex overflow-y-scroll flex-col gap-4 mb-4 w-full max-h-[600px]"
        @scroll="onContentScroll"
      >
        <p>
          <span class="font-semibold">Restricted Access:</span> If you are
          legally restricted or prohibited from accessing or using this website
          in your jurisdiction, you must not access or use this site.
        </p>
        <p>
          <span class="font-semibold">Not an Offer or Solicitation:</span> The
          content on this website does not constitute an offer, invitation, or
          solicitation to buy, sell, or subscribe to any securities,
          derivatives, investment contracts, or financial instruments. It is not
          intended to be and should not be interpreted as advice or a
          recommendation concerning any financial products. None of the
          information provided is intended to solicit the provision of any
          consumer credit services, deposit facilities, or other financial
          services of any kind in any jurisdiction.
        </p>
        <p>
          <span class="font-semibold">Jurisdictional Availability:</span> The
          availability of services described on this website may be limited by
          regional legal restrictions and may not be accessible by all users.
          Some services may be restricted exclusively to sophisticated,
          accredited, or professional investors under the laws of certain
          jurisdictions. Subscribing to free or subscription-based content does
          not imply eligibility for other services offered by Untangled.
        </p>
        <p>
          <span class="font-semibold">Personal Use Only:</span> Materials
          provided on this website are intended solely for your personal,
          non-commercial use. These materials are not directed at, intended for
          distribution to, or use by any person in any jurisdiction where such
          distribution or use would be contrary to local law or regulation.
        </p>
        <p>
          <span class="font-semibold">No Licensing or Promotion:</span>
          Untangled is not licensed in all jurisdictions. We do not actively
          promote or market our services, tokens, or pools in jurisdictions
          where such activities are prohibited by law. Users are responsible for
          ensuring they comply with local regulations concerning virtual assets.
        </p>
        <p>
          <span class="font-semibold">High Risk of Virtual Assets:</span>
          Investing in virtual assets and pools involves substantial risk,
          including the potential loss of principal. These products are
          unregulated and may be highly volatile. Investors should be aware of
          the legal and regulatory requirements within their jurisdictions and
          should obtain appropriate professional advice to understand potential
          risks fully.
        </p>
        <p>
          <span class="font-semibold">No Warranties:</span>
          No representation or warranty is made by Untangled, its affiliates,
          directors, officers, or employees regarding the suitability of virtual
          assets or pools as investments. All investments should be considered
          as bearing high risk, and you should consult with a professional
          advisor before making any investment decisions.
        </p>
        <p>
          <span class="font-semibold">Market Information:</span>
          All market information is provided "as is" and is not guaranteed for
          accuracy or completeness. Untangled does not take responsibility for
          this information or its use. Prices and market data are indicative and
          subject to change without notice.
        </p>
        <p>
          <span class="font-semibold">Liability Limitation:</span>
          Unless explicitly required by law, Untangled, its affiliates, and
          their respective officers, directors, employees, or agents will not be
          liable for any losses or damages arising out of or related to the use
          of this website or its content. This includes, without limitation, any
          loss of profit, loss of data, or incidental or consequential damages.
        </p>
        <p>
          <span class="font-semibold">Governing Law and Jurisdiction:</span>
          This disclaimer is governed by English law and is subject to the
          exclusive jurisdiction of the courts of the Cayman Islands for any
          disputes.
        </p>
        <p>
          <span class="font-semibold">Acknowledgment of Risks:</span>
          By accessing and using this website, you acknowledge and accept that
          investment in virtual assets and pools carries inherent risks and
          agree that you are solely responsible for any investment decisions and
          the resultant financial outcomes.
        </p>
      </div>
      <BalBtn
        :disabled="!bottomReached"
        block
        :color="!bottomReached ? 'gray' : 'green'"
        @click="onClose"
        >Okay</BalBtn
      >
    </BalModal>
  </teleport>
</template>


